// mixins/portalConfigMixin.js (修改后的原有 mixin)
import { clientPortalSettings } from "@/api/member";

export const portalConfigMixin = {
  data() {
    return {
      portalConfig: {
        name: '',
        logo: '',
        theme_color: '#007bff',
        background_image: '',
        enable_registration: false,
      },
      configLoaded: false
    };
  },

  async created() {
    await this.loadPortalConfig();
  },

  methods: {
    // 加载客户中心配置
    async loadPortalConfig() {
      try {
        const response = await clientPortalSettings();
        console.log(response);

        if (response.code === 200 && response.body) {
          const data = response.body;
          this.portalConfig = {
            name: data.name || '',
            logo: data.logo || '',
            theme_color: data.brand_color || data.theme_color || '#007bff',
            background_image: data.background_image || '',
            enable_registration: data.enable_registration || false,
          };

          // 将 enable_registration 存储到 Vuex
          this.$store.dispatch('portal/setRegistrationEnabled', response.body.enable_registration);
        }
        this.configLoaded = true;
        // 标记配置已加载到 Vuex
        this.$store.dispatch('portal/setConfigLoaded', true);
      } catch (error) {
        console.error('加载客户中心配置失败:', error);
        this.configLoaded = true; // 即使失败也标记为已加载，使用默认配置
        this.$store.dispatch('portal/setConfigLoaded', true);
      }
    },

    // 刷新配置（可选方法，用于配置更新后重新加载）
    async refreshPortalConfig() {
      this.configLoaded = false;
      this.$store.dispatch('portal/setConfigLoaded', false);
      await this.loadPortalConfig();
    }
  },

  computed: {
    // 计算属性，用于动态样式
    portalStyles() {
      return {
        '--theme-color': this.portalConfig.theme_color,
        '--background-image': this.portalConfig.background_image ? `url(${this.portalConfig.background_image})` : 'none',
      };
    }
  }
};